var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-1 login-wrapper"},[_c('v-card-title',[_vm._v("U wordt nu uitgelogd..")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }